import React from 'react'
import { Grid } from 'semantic-ui-react'

export const CenteredLayout: React.FC<{}> = ({ children }) => (
  <Grid container textAlign="center">
    <Grid.Row>
      <Grid.Column style={{ maxWidth: 450 }}>{children}</Grid.Column>
    </Grid.Row>
  </Grid>
)
